import React from 'react';
import Rectangle from '@splunk/dashboard-visualizations/Rectangle';

export default () => <Rectangle options={{}} />;
